module.exports = __webpack_public_path__ + "img/chart-part-6-servicekind.73346104.png";